import React, { useState } from "react";
import { Accordion, Container, Row, Col } from "react-bootstrap";
import "./question.css";

const QuestionRC = () => {
  const [activeKeys, setActiveKeys] = useState([]);

  const handleToggle = (eventKey) => {
    setActiveKeys((prev) =>
      prev.includes(eventKey)
        ? prev.filter((key) => key !== eventKey)
        : [...prev, eventKey]
    );
  };

  return (
    <Container className="my-5">
      <h2 className="text-center mb-4 fs-40">FAQs</h2>
      <Row className="p-4">
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="bg-faq no-border mb-3"
              eventKey="0"
              onClick={() => handleToggle("0")}
            >
              <Accordion.Header as="h3" className="red-header">
                What is root canal treatment?
              </Accordion.Header>
              <Accordion.Body>
                Root canal treatment is a procedure that removes infection from
                the inside of a tooth, saving it from extraction and restoring
                it to full health.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="1"
              onClick={() => handleToggle("1")}
            >
              <Accordion.Header as="h3" className="red-header">
                Why might I need a root canal?
              </Accordion.Header>
              <Accordion.Body>
                You may need a root canal if the pulp inside your tooth becomes
                infected or damaged, often due to deep decay, a crack, or
                trauma. Without treatment, the infection could spread and cause
                more serious problems.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="4"
              onClick={() => handleToggle("4")}
            >
              <Accordion.Header as="h3" className="red-header">
                Does root canal treatment hurt?
              </Accordion.Header>
              <Accordion.Body>
                Not at all! Thanks to modern techniques and gentle care, having
                a root canal feels much like having a standard filling. We’ll
                make sure you are comfortable and well looked after throughout.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="7"
              onClick={() => handleToggle("7")}
            >
              <Accordion.Header as="h3" className="red-header">
                What are the signs I might need a root canal?
              </Accordion.Header>
              <Accordion.Body>
                Common signs include toothache, sensitivity to hot and cold,
                swelling, tenderness, or darkening of the tooth. However,
                sometimes there are no symptoms, which is why regular check-ups
                are so important.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="8"
              onClick={() => handleToggle("8")}
            >
              <Accordion.Header as="h3" className="red-header">
                How long does root canal treatment take?
              </Accordion.Header>
              <Accordion.Body>
                It usually takes one or two appointments, depending on the
                complexity of the tooth. We'll let you know exactly what to
                expect during your consultation.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
        <Col md={6}>
          <Accordion activeKey={activeKeys}>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="3"
              onClick={() => handleToggle("3")}
            >
              <Accordion.Header as="h3" className="red-header">
                What happens during the procedure?
              </Accordion.Header>
              <Accordion.Body>
                We gently remove the infected or damaged tissue, carefully clean
                and disinfect the inside of the tooth, and then seal it to
                prevent further infection. Often, a crown is placed afterwards
                to strengthen the tooth.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="2"
              onClick={() => handleToggle("2")}
            >
              <Accordion.Header as="h3" className="red-header">
                Will I need a crown after my root canal?
              </Accordion.Header>
              <Accordion.Body>
                In many cases, especially for back teeth, a crown is recommended
                to protect and strengthen the tooth after treatment.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="9"
              onClick={() => handleToggle("9")}
            >
              <Accordion.Header as="h3" className="red-header">
                How successful is root canal treatment?
              </Accordion.Header>
              <Accordion.Body>
                Root canal treatment is highly successful and can keep your
                tooth healthy for many years. We use the latest techniques and
                materials to give you the best possible outcome.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="10"
              onClick={() => handleToggle("10")}
            >
              <Accordion.Header as="h3" className="red-header">
                What should I expect after the treatment?
              </Accordion.Header>
              <Accordion.Body>
                It’s normal to feel a little tender for a few days, but this
                usually settles quickly. We’ll give you all the advice you need
                to ensure a smooth recovery.
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              className="no-border bg-faq mb-3"
              eventKey="11"
              onClick={() => handleToggle("11")}
            >
              <Accordion.Header as="h3" className="red-header">
                How do I book a consultation for root canal treatment?
              </Accordion.Header>
              <Accordion.Body>
                If you’re experiencing any dental pain or concerns, simply get
                in touch with us. Our caring team at Regent Dental is here to
                help you feel better and protect your smile.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

export default QuestionRC;
